<template>
  <b-row class="container">
    <b-col class="label mb-1" :cols="labelCols ? labelCols : '5'">
      {{ label }}
    </b-col>
    <b-col v-if="!editMode" class="value" :cols="valueCols ? valueCols : '7'">
      <slot name="value">
        {{ printValue(value) }}
      </slot>
    </b-col>
    <b-col v-else class="value" :cols="valueCols ? valueCols : '7'">
      <validation-provider
          v-slot="{ validate, changed, dirty, valid, errors }"
          :rules="rules"
          :detect-input="detectInput"
          :vid="vid"
          immediate
          ref="provider"
      >
        <slot name="input" v-bind:state="(changed || dirty) ? valid : null" v-bind:validate="validate"/>
        <fa-icon :icon="['fa', 'pen']" class="ml-1"/>
        <div v-if="!valid && errors.length" class="error-text text-red ml-1">
          {{ errors[0] }}
        </div>
      </validation-provider>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider } from "vee-validate"
import { capitalize } from "lodash"

export default {
  name: "DistributionDetailField",
  components: { ValidationProvider },
  props: {
    label: String,
    rules: String,
    vid: String,
    editMode: {
      type: Boolean,
      default: false,
    },
    value: {
      required: false,
    },
    detectInput: {
      default: true,
    },
    labelCols: String,
    valueCols: String,
  },
  methods: {
    setErrors (errors) {
      this.$refs.provider.setErrors(errors)
      this.$refs.provider.setFlags({ dirty: true })
    },
    printValue (value) {
      if (typeof value === "boolean") {
        return capitalize(value ? this.$t("yes") : this.$t("no"))
      }
      if (!value) {
        return "-"
      }
      return value
    }
  }
}
</script>

<style scoped lang="scss">
.label {
    font-weight: 700;
    display: inline;
    margin: 0 !important;
    align-content: center;
}

.value {
  display: inline;
}

.container {
    min-height: 50px;
    align-content: center;
    padding: 0;
}

::v-deep .form-control {
    height: 32px;
    width: 200px;
    display: inline-block;
}

::v-deep .input-group-append {
    width: 50px;
    .input-group-text, .custom-select {
      background-color: #ffffff;
    }
}

::v-deep textarea.form-control {
    width: 98%;
    height: 150px;
}

::v-deep .input-group {
    height: 32px;
    display: inline-flex;
    width: 200px;
}

::v-deep .input-group .form-control {
    width: 150px;
}


::v-deep .mx-input {
    height: 32px;
}

::v-deep .mx-datepicker {
    width: 200px;
    display: inline-block;

    &.invalid {
        .mx-input {
            border-color: var(--red);
        }
    }
}

::v-deep .multiselect {
    height: 32px;
    width: auto;
    display: inline-block;
}

::v-deep div[role=radiogroup] {
    display: inline-block;
    height: 32px;
    line-height: 32px;

    label::before, label::after {
        top: calc(5px + 0.25rem);
    }
}

::v-deep .custom-select:not(.input-group .custom-select) {
    width: 200px;
}

</style>
